<template>
  <div>
    <p v-if="label" class="label">{{ label }}</p>
    <a-radio-group v-if="!multiple" :value="defaultValue" @change="onChange">
      <a-radio-button
        v-a11y-tab:outer-shadow
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        :class="option.itemClass"
      >{{ option.label }}</a-radio-button>
    </a-radio-group>

    <r-checkbox-group
      v-else
      :name="name"
      :value="defaultValue"
      @change="onChange"
      class="section-group"
    >
      <r-checkbox-wrapper>
        <r-checkbox-button
          v-a11y-tab:outer-shadow
          v-for="option in options"
          :key="option.value"
          :value="option.value"
          :class="option.itemClass"
        >{{ option.label }}</r-checkbox-button>
      </r-checkbox-wrapper>

      <r-checkbox-wrapper>
        <slot />
      </r-checkbox-wrapper>
    </r-checkbox-group>
  </div>
</template>

<script>
import RCheckboxGroup from '@/components/common/CheckboxGroup.vue';
import RCheckboxButton from '@/components/common/CheckboxButton.vue';
import RCheckboxWrapper from '@/components/common/CheckboxWrapper.vue';

export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    defaultValue: undefined,
    label: String,
    multiple: {
      type: Boolean,
      default: false,
    },
    name: String,
  },
  components: {
    RCheckboxGroup,
    RCheckboxButton,
    RCheckboxWrapper,
  },
  methods: {
    onChange(e) {
      this.$emit('change', e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts.scss';

.label {
  text-transform: capitalize;
  margin: 10px 5px 0 5px;
  font-size: 11px;
  letter-spacing: 0.71px;
  line-height: 14px;
}
</style>
